import React from "react";

interface CircleFlagProps
  extends React.ImgHTMLAttributes<HTMLImageElement> {
  /**
   * Circle-flags code: ISO 3166-1 alpha-2 (lowercase), plus the home-nation
   * codes `gb-eng` / `gb-sct`. Resolves to a local SVG under
   * `public/images/flags/<code>.svg`.
   */
  countryCode: string;
}

/**
 * Drop-in replacement for `react-circle-flags`' `CircleFlag` that serves the
 * pre-rounded flag SVGs bundled in `public/images/flags` instead of fetching
 * them from a CDN. Same name/props, so call sites only change their import path.
 */
export const CircleFlag: React.FC<CircleFlagProps> = ({
  countryCode,
  height = 100,
  alt,
  ...rest
}) => (
  <img
    src={`/images/flags/${countryCode}.svg`}
    alt={alt ?? countryCode}
    height={height}
    loading="lazy"
    {...rest}
  />
);

export default CircleFlag;
